import z from 'zod'

/** Coerce region codes from JSON search params (number or quoted string). */
const regionCodeSchema = z.preprocess(value => {
  if (value === null || value === undefined || value === '') {
    return undefined
  }

  if (typeof value === 'number') {
    return String(value)
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (
      trimmed.length >= 2 &&
      trimmed.startsWith('"') &&
      trimmed.endsWith('"')
    ) {
      try {
        return String(JSON.parse(trimmed))
      } catch {
        return trimmed.slice(1, -1)
      }
    }
    return trimmed
  }

  return value
}, z.string().optional())

export const poktanStatusSchema = z.enum(['active', 'inactive', 'semua'])

export const searchParamsSchema = z.object({
  poktan_status: z.string().optional(),
  search: z.string().optional(),
  province_code: regionCodeSchema,
  city_code: regionCodeSchema,
  district_code: regionCodeSchema,
  village_code: regionCodeSchema,
  poktan_class_id: z.string().optional(),
  poktan_usaha_id: z.string().optional(),
  poktan_type_id: z.string().optional(),
  poktan_program_id: z.string().optional(),
  per_page: z.number().min(10).max(100).default(10),
  page: z.number().min(1).default(1),
  status: poktanStatusSchema.default('active')
})

export type SearchParams = z.infer<typeof searchParamsSchema>
export type PoktanStatusFilter = z.infer<typeof poktanStatusSchema>
